import React from 'react';
import type { TitleProps } from './title.types';
import { TITLE_VARIANTS, SKELETON_VARIANTS } from './title.constants';
import styles from './title.module.css';

import { Skeleton } from '../skeleton';

export const Title = ({
    children,
    variant = 'h1',
    className = '',
    isLoading,
    as,
}: TitleProps) => {
    const Component = as || variant;
    const variantClass = TITLE_VARIANTS[variant];
    const skeletonClass = SKELETON_VARIANTS[variant];

    if (isLoading) {
        return <Skeleton className={`${styles[skeletonClass]} ${className}`.trim()} />;
    }

    return (
        <Component className={`${styles.core} ${styles[variantClass]} ${className}`.trim()}>
            {children}
        </Component>
    );
};

export const H1 = (props: Omit<TitleProps, 'variant'>) => <Title variant="h1" {...props} />;
export const H2 = (props: Omit<TitleProps, 'variant'>) => <Title variant="h2" {...props} />;
export const H3 = (props: Omit<TitleProps, 'variant'>) => <Title variant="h3" {...props} />;
export const H4 = (props: Omit<TitleProps, 'variant'>) => <Title variant="h4" {...props} />;
export const H5 = (props: Omit<TitleProps, 'variant'>) => <Title variant="h5" {...props} />;
export const H6 = (props: Omit<TitleProps, 'variant'>) => <Title variant="h6" {...props} />;